import React, { useMemo } from 'react'
import { cloneDeep } from 'lodash'
import { Stack, Grid, Box, Divider, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { useGetSupplierTypesQuery, useGetVendorClassesQuery } from 'services/customers'

import Input from 'components/generic/form/Input'
import Select from 'components/generic/form/Select'
import { ALL_PAYMENT_METHOD_OPTIONS } from 'utils/constants'
import { sortSupplierTypeVendorClass } from 'utils/data-manipulation/common'

const CustomerAdditionalInformationForm = ({ control, errors, contactIndex }) => {
  const { data: vendorClassesData } = useGetVendorClassesQuery({})
  const { data: supplierTypesData } = useGetSupplierTypesQuery({})
  const { hasAtm, details } = useSelector(state => state.settings)
  const yardHasGsPayConfigured = details.gsPayEnabled
  const filteredSupplierTypes = cloneDeep(supplierTypesData?.Items || [])
    .filter(item => !!item.active)
    .sort(sortSupplierTypeVendorClass)
  const filteredVendorClasses = cloneDeep(vendorClassesData?.Items || [])
    .filter(item => !!item.active)
    .sort(sortSupplierTypeVendorClass)

  const PAYMENT_METHOD_OPTIONS = useMemo(
    () =>
      ALL_PAYMENT_METHOD_OPTIONS?.filter(
        method => (hasAtm ? true : method.id !== 'atm') && (yardHasGsPayConfigured ? true : method.id !== 'gs_pay'),
      ),
    [hasAtm, yardHasGsPayConfigured],
  )

  return (
    <Stack flexGrow={1} sx={{ pl: 3, pr: 4 }}>
      <Box>
        <Typography variant="h6" color="textSecondary">
          Additional Information
        </Typography>
        <Box py={1}>
          <Divider />
        </Box>
        <Grid direction="column" container item md={6} xs={12} mt={1} spacing={2}>
          <Grid item md={6} xs={12}>
            <Select
              name="supplierTypeId"
              label="Supplier Type"
              defaultValue=""
              control={control}
              items={filteredSupplierTypes}
              error={!!errors.supplierTypeId}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Select
              name="vendorClassId"
              label="Vendor Class"
              defaultValue=""
              control={control}
              items={filteredVendorClasses}
              error={!!errors.vendorClassId}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Select
              name="preferredPaymentMethod"
              label="Preferred Payment Method"
              defaultValue=""
              control={control}
              items={PAYMENT_METHOD_OPTIONS}
              error={!!errors.preferredPaymentMethod}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Input
              label="Phone Number"
              defaultValue=""
              control={control}
              error={!!errors.contacts?.[contactIndex]?.phone1}
              helperText={errors.contacts?.[contactIndex]?.phone1?.message}
              name={`contacts.${contactIndex}.phone1`}
            />
          </Grid>
          <Grid item md={6} xs={12}>
            <Input
              label="Email"
              defaultValue=""
              control={control}
              error={!!errors.contacts?.[contactIndex]?.email}
              helperText={errors.contacts?.[contactIndex]?.email?.message}
              name={`contacts.${contactIndex}.email`}
            />
          </Grid>
        </Grid>
        <Grid container mt={1} spacing={1}>
          <Grid item md={12} xs={12}>
            <Input
              name="notes"
              label="Identifying Notes"
              defaultValue=""
              control={control}
              error={!!errors.notes}
              helperText={errors.notes?.message}
            />
          </Grid>
        </Grid>
      </Box>
    </Stack>
  )
}

CustomerAdditionalInformationForm.propTypes = {
  control: PropTypes.object,
  errors: PropTypes.object,
  contactIndex: PropTypes.string.isRequired,
}

CustomerAdditionalInformationForm.defaultProps = {
  control: {},
  errors: {},
}

export default CustomerAdditionalInformationForm
